import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Button, Modal } from 'fpay-ui';
import useBreakpoint from '@hooks/breakpoint';

const Title = styled.div(
  ({ theme }) => css`
    text-align: center !important;
    color: ${theme.colors.gray800};
    ${theme.textTypes['H6-w400']}
    margin-top: 27.3px;
    ${theme.breakpoint('md')} {
      margin-top: 40px;
    }
  `
);

const SubTitle = styled.div(
  ({ theme }) => css`
    text-align: center !important;
    color: ${theme.colors.gray700};
    ${theme.textTypes['Body-2-w500']}
    margin: 13px auto 24px;
  `
);

const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 16.4px 24px 18px;
    ${theme.breakpoint('md')} {
      margin: 24.4px 32px 22px;
    }
  `
);

const ButtonsContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    ${theme.breakpoint('md')} {
      width: 200px;
    }
    button {
      text-align: center;
      margin-top: 10px;
      ${theme.breakpoint('md')} {
        margin-top: 16px;
      }
    }
    button:first-child {
      margin-top: 0;
    }
  `
);

/**
 * Component for confirm or cancel in modal format
 * @param open Boolean used for component rendering
 * @param title Title of ConfirmModal
 * @param subTitle SubTitle of ConfirmModal
 * @param handleConfirm Function of action confirm
 * @param textConfirm Text in Button confirm
 * @param handleCancel Function of action cancel *&* close of Modal
 * @param textCancel Text in Button cancel
 * @param imageSourceUrl Url of image used in top of ConfirmModal
 * @param imageStyle Styled used by img
 * @param imageAlt Alt used by img
 */
const ConfirmModal = ({
  title,
  subTitle,
  handleConfirm,
  textConfirm,
  handleCancel,
  textCancel,
  open,
  imageSourceUrl,
  imageStyle,
  imageAlt,
}) => {
  const { mobile } = useBreakpoint();

  return (
    <>
      {open && (
        <Modal
          open={open}
          fClose={() => handleCancel && handleCancel(true)}
          showCloseButton={false}
          width={mobile ? 'auto' : '400px'}
        >
          <Container data-testid="c-m-container">
            {imageSourceUrl && (
              <img data-testid="c-m-img" src={imageSourceUrl} style={imageStyle} alt={imageAlt} />
            )}
            <Title data-testid="c-m-title">{title}</Title>
            <SubTitle data-testid="c-m-subtitle">{subTitle}</SubTitle>
            <ButtonsContainer>
              <Button data-testid="c-m-confirm-button" onClick={handleConfirm}>
                {textConfirm}
              </Button>
              <Button data-testid="c-m-cancel-button" type="link" onClick={handleCancel}>
                {textCancel}
              </Button>
            </ButtonsContainer>
          </Container>
        </Modal>
      )}
    </>
  );
};
export default ConfirmModal;

ConfirmModal.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  handleConfirm: PropTypes.func,
  textConfirm: PropTypes.string,
  handleCancel: PropTypes.func,
  textCancel: PropTypes.string,
  open: PropTypes.bool,
  imageSourceUrl: PropTypes.string,
  imageStyle: PropTypes.object,
  imageAlt: PropTypes.string,
};

ConfirmModal.defaultProps = {
  title: undefined,
  subTitle: undefined,
  handleConfirm: undefined,
  textConfirm: 'Confirmar',
  handleCancel: undefined,
  textCancel: 'Cancelar',
  open: undefined,
  imageSourceUrl: undefined,
  imageStyle: undefined,
  imageAlt: undefined,
};
